import { render, staticRenderFns } from "./problemSolvingChart.vue?vue&type=template&id=39104f32&scoped=true"
import script from "./problemSolvingChart.vue?vue&type=script&lang=js"
export * from "./problemSolvingChart.vue?vue&type=script&lang=js"
import style0 from "./problemSolvingChart.vue?vue&type=style&index=0&id=39104f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39104f32",
  null
  
)

export default component.exports